import api from './axios';

export interface ContractVehicle {
    placa: string;
    tipo: string;
    marca: string;
    modelo?: string;
    color?: string;
    vehiculo?: any;
}

export interface Contract {
    id: string;
    tipoContrato: 'INDIVIDUAL' | 'EMPRESARIAL';
    cliente: string;
    empresa?: string;
    documento: string;
    telefono?: string;
    email?: string;
    direccion?: string;
    plan: 'MENSUAL' | 'TRIMESTRAL' | 'SEMESTRAL' | 'ANUAL';
    valorMensual: number;
    fechaInicio: string;
    fechaFin: string;
    status: 'ACTIVO' | 'VENCIDO' | 'CANCELADO';
    renovacionAutomatica: boolean;
    observaciones?: string;
    contractVehicles?: { vehiculo: ContractVehicle }[];
    vehiculos?: ContractVehicle[]; // For frontend convenience in forms
}

export interface CreateContractDto {
    tipoContrato: 'INDIVIDUAL' | 'EMPRESARIAL';
    cliente: string;
    empresa?: string;
    documento: string;
    telefono?: string;
    email?: string;
    direccion?: string;
    plan: string;
    valorMensual: number;
    fechaInicio: string;
    renovacionAutomatica?: boolean;
    observaciones?: string;
    vehiculos: ContractVehicle[];
}

export const getContracts = async () => {
    const response = await api.get<Contract[]>('/contracts');
    return response.data;
};

export const createContract = async (data: CreateContractDto) => {
    const response = await api.post<Contract>('/contracts', data);
    return response.data;
};

export const updateContract = async (id: string, data: Partial<CreateContractDto>) => {
    const response = await api.patch<Contract>(`/contracts/${id}`, data);
    return response.data;
};

export const deleteContract = async (id: string) => {
    const response = await api.delete<Contract>(`/contracts/${id}`);
    return response.data;
};

export const toggleContractStatus = async (id: string) => {
    const response = await api.patch<Contract>(`/contracts/${id}/toggle-status`);
    return response.data;
};

export const sendContractReminder = async (id: string) => {
    const response = await api.post(`/contracts/${id}/send-reminder`);
    return response.data;
};

export interface ContractPaymentDto {
    monto: number;
    metodoPago: 'EFECTIVO' | 'TARJETA' | 'QR' | 'TRANSFERENCIA' | 'DEBITO' | 'CREDITO';
    meses?: number;
    observaciones?: string;
}

export interface DailyPaymentSummary {
    date: string;
    total: number;
    summary: {
        metodo: string;
        total: number;
        count: number;
    }[];
    transactions: any[];
}

export const addContractPayment = async (contractId: string, data: ContractPaymentDto) => {
    const response = await api.post(`/contracts/${contractId}/payment`, data);
    return response.data;
};

export const getDailyContractPayments = async (date?: string) => {
    const params = date ? { date } : {};
    const response = await api.get<DailyPaymentSummary>('/contracts/payments/daily', { params });
    return response.data;
};
